import { createContext, useContext } from 'react';

import { INotifications } from '../../core/notifications';

const storeContext = createContext<INotifications | undefined>(undefined);

export const NotificationsProvider = storeContext.Provider;

export const useNotify = () => {
  const notify = useContext(storeContext);

  if (notify === undefined) {
    throw new Error('useNotify must be within NotificationsProvider');
  }

  return notify;
};
